// All salon services & courses — no prices, only names
export const BRAND = {
  name: "99 Institute of Beauty & Wellness",
  short: "99 Salon & Academy",
  city: "Patiala, Punjab",
  pin: "147001",
  address:
    "Near Fountain Chowk, Back Side Bhagat Petrol Pump, Patiala 147001, Punjab",
  phones: ["8437646000", "8437041000"],
  primaryPhone: "8437646000",
  email: "info.99pta@gmail.com",
  instagram: "https://www.instagram.com/99salonandacademypatiala",
  instagramHandle: "@99salonandacademypatiala",
  facebook: "https://www.facebook.com/share/1BhdP7dW2j/?mibextid=wwXIfr",
  facebookHandle: "Ninetynine Patiala",
  timings: "10:00 AM – 8:00 PM",
  whatsappMessage:
    "Hi 99 Institute of Beauty and Wellness. I just had a look at your website and I am willing to make an appointment.",
};

export const whatsappHref = () => {
  const num = "91" + BRAND.primaryPhone;
  const msg = encodeURIComponent(BRAND.whatsappMessage);
  return `https://wa.me/${num}?text=${msg}`;
};

export const LOGOS = {
  main: "/logo-99.png",
  iao: "/logo-iao.png",
};

export const STUDENT_PHOTOS = [
  {
    src: "/gallery/students/s1.jpg",
    kicker: "Theory",
    title: "Classroom sessions",
    caption:
      "White coats, live notes, and syllabus books built around the IAO curriculum.",
  },
  {
    src: "/gallery/students/s2.jpg",
    kicker: "Live Demo",
    title: "Chairside masterclass",
    caption:
      "Seniors demonstrate on real clients — every seat gets the same close-up view.",
  },
  {
    src: "/gallery/students/s3.jpg",
    kicker: "Graduation",
    title: "Certified & shipped",
    caption:
      "Diplomas in Cosmetology, Hair Designing, Makeup and more — IAO-endorsed.",
  },
];

export const INTERIOR_IMAGES = [
  "/gallery/exterior.jpg",
  "/gallery/interior-1.webp",
  "/gallery/interior-2.webp",
  "/gallery/interior-3.webp",
];

export const WORK_GALLERY = [
  {
    title: "Bridal Makeup",
    caption: "Traditional bridal edit",
    src: "/gallery/work/1-skin.jpg",
  },
  {
    title: "Bridal Hair",
    caption: "Half-up with florals",
    src: "/gallery/work/3-bridal-hair.jpg",
  },
  {
    title: "Hair",
    caption: "Balayage, waved",
    src: "/gallery/work/4-nails.jpg",
  },
  {
    title: "Nails",
    caption: "Nude & brown art",
    src: "/gallery/work/2-hair.jpg",
  },
  {
    title: "Skin",
    caption: "Facial ritual",
    src: "/gallery/work/5-bridal-makeup.jpg",
  },
];

// SERVICES — grouped by high-level buckets
export const SERVICE_CATEGORIES = [
  {
    id: "hair",
    label: "Hair",
    tagline: "Cut. Shape. Restore. Colour.",
    groups: [
      {
        title: "Hair Cut & Head Wash",
        items: [
          "Trimming",
          "Head Wash",
          "Normal Hair Cut",
          "Professional Hair Cut",
        ],
      },
      {
        title: "Hair Styling",
        items: [
          "Flat Blow Dry",
          "Advanced Blow Dry",
          "Styling Curl",
          "Hair Do's",
          "Advanced Hair Do's",
        ],
      },
      {
        title: "Hair Treatment",
        items: [
          "Head Massage",
          "Deep Conditioning",
          "Basic Hair Spa",
          "Matrix Hair Spa",
          "Hair Spa (L'Oréal)",
          "Hair Spa (Schwarzkopf)",
          "Keratin Hair Spa",
          "Anti-Dandruff Treatment",
          "Hair Loss Treatment",
          "Power Doze Treatment",
          "Hair Polishing",
          "Wellaplex Treatment",
          "Olaplex Treatment",
        ],
      },
      {
        title: "Streaks",
        items: ["Single Streak", "Crown", "Full Head"],
      },
      {
        title: "Hair Colour — Global",
        items: [
          "Root Touch Up",
          "Small Length",
          "Medium Length",
          "Long Length",
          "Ombre / Balayage",
          "3D Colouring",
          "Colour Change",
        ],
      },
      {
        title: "Smoothening + Rebonding",
        items: ["Small Length", "Medium Length", "Long Length"],
      },
      {
        title: "Keratin Treatment",
        items: ["Small Length", "Medium Length", "Long Length"],
      },
    ],
  },
  {
    id: "skin",
    label: "Skin",
    tagline: "Cleanse. Nourish. Reveal.",
    groups: [
      {
        title: "Facials",
        items: [
          "Clean Up",
          "Basic Cleansing",
          "Deep Cleansing",
          "D-Tan Facial",
          "Whitening Facial",
          "Nourishing Facial",
          "Aroma Therapy Facial",
          "O3+ Facial",
          "Organic Facial",
          "Kanpeki Facial",
          "Hydra Facial",
        ],
      },
      {
        title: "Skin Treatments",
        items: ["Acne", "Blemishes"],
      },
      {
        title: "Bleach",
        items: [
          "Face & Neck Bleach",
          "Foot Bleach",
          "Half Back",
          "Full Back",
          "Full Body Bleach",
          "Special Bridal Bleach",
        ],
      },
      {
        title: "Threading & Face",
        items: [
          "Eye Brow",
          "Upper Lips",
          "Chin",
          "Forehead",
          "Cheeks",
          "Full Face Threading",
          "Full Face Wax",
        ],
      },
    ],
  },
  {
    id: "makeup",
    label: "Makeup",
    tagline: "Occasion. Emotion. Craft.",
    groups: [
      {
        title: "Party Make-Up",
        items: [
          "Kryolan",
          "Make-up Studio",
          "MAC",
          "Air Brush Make-Up",
          "HD Make-Up",
          "Celebrity Make-Up",
        ],
      },
      {
        title: "Engagement Make-Up",
        items: [
          "Kryolan",
          "Make-up Studio",
          "MAC",
          "Air Brush Make-Up",
          "HD Make-Up",
          "Celebrity Make-Up",
        ],
      },
      {
        title: "Bridal Make-Up",
        items: [
          "Kryolan",
          "Make-up Studio",
          "MAC",
          "Air Brush Make-Up",
          "HD Make-Up",
          "Celebrity Make-Up",
        ],
      },
      {
        title: "Reception Make-Up",
        items: [
          "Kryolan",
          "Make-up Studio",
          "MAC",
          "Air Brush Make-Up",
          "HD Make-Up",
          "Celebrity Make-Up",
        ],
      },
    ],
  },
  {
    id: "nails",
    label: "Nails",
    tagline: "Sculpted. Painted. Perfected.",
    groups: [
      {
        title: "Nail Arts & Extensions",
        items: [
          "Nail Filing & Nail Polishing",
          "Basic Nail Art",
          "French Nail Art",
          "Acrylic Nail Extension",
          "Gel Nail Extension",
          "French Nail Extension",
          "Toe Extension",
          "Toe Power Polish",
          "Power Polish",
          "Gel Overlay",
          "Refilling",
          "Removal",
        ],
      },
      {
        title: "Manicure",
        items: [
          "Classic Manicure",
          "D-Tan Manicure",
          "Paraffin Manicure",
          "Spa Manicure",
          "Organic Manicure",
        ],
      },
      {
        title: "Pedicure",
        items: [
          "Classic Pedicure",
          "D-Tan Pedicure",
          "Paraffin Pedicure",
          "Spa Pedicure",
          "Organic Pedicure",
        ],
      },
    ],
  },
  {
    id: "body",
    label: "Body & Waxing",
    tagline: "Slow rituals for the whole self.",
    groups: [
      {
        title: "Body",
        items: [
          "Foot Reflexology",
          "Swedish Body Massage",
          "Deep Tissue Massage",
          "Aroma Therapy",
          "Body Polishing",
          "Body Spa",
          "Chocolate Body Wrap",
          "Organic Body Spa",
        ],
      },
      {
        title: "Waxing — Honey",
        items: [
          "Under Arms",
          "Half Arms",
          "Half Legs",
          "Full Arms",
          "Full Legs",
          "Back Wax",
          "Full Body",
          "B-Wax",
        ],
      },
      {
        title: "Waxing — Rica",
        items: [
          "Under Arms",
          "Half Arms",
          "Half Legs",
          "Full Arms",
          "Full Legs",
          "Back Wax",
          "Full Body",
          "B-Wax",
        ],
      },
    ],
  },
];

// COURSES — Academy
export const COURSES = {
  Certificate: [
    { name: "Certificate in Basic Beauty & Hair", duration: "2 Months" },
    { name: "Certificate in Art of Makeup", duration: "2 Months" },
    { name: "Certificate in Basic & Advance Beauty", duration: "2 Months" },
    { name: "Certificate in Basic & Advance Hair", duration: "2 Months" },
    { name: "Certificate in Hair Cuts", duration: "1 Month" },
    { name: "Certificate in Nail Extension", duration: "1 Month" },
    { name: "Certificate in Aroma Therapy", duration: "1 Month" },
    { name: "Certificate in Air Brush", duration: "15 Days" },
    { name: "Certificate in Nail Art", duration: "15 Days" },
    { name: "Certificate in Mehndi", duration: "15 Days" },
    { name: "Certificate in Self Grooming", duration: "15 Days" },
    { name: "Certificate in Saree & Dupatta Draping", duration: "10 Days" },
    { name: "Certificate in Trendy Hair Do's", duration: "10 Days" },
    { name: "Certificate in Threading", duration: "7 Days" },
  ],
  Diploma: [
    { name: "Diploma in Hair Designing", duration: "4 Months" },
    { name: "Diploma in Beauty Culture", duration: "4 Months" },
    { name: "Diploma in Makeup", duration: "3 Months" },
    { name: "Diploma in Nail Art & Extensions", duration: "2 Months" },
    { name: "Diploma in Body", duration: "2 Months" },
    { name: "Diploma in Spa", duration: "2 Months" },
  ],
  "Long-Term": [
    { name: "Masters in Cosmetology", duration: "2 Years" },
    { name: "Post Graduate Diploma in Cosmetology", duration: "1.5 Years" },
    {
      name: "Advance Diploma in Cosmetology & Hair Designing",
      duration: "1 Year",
    },
    { name: "Diploma in Cosmetology", duration: "6 Months" },
  ],
};

export const CHAPTERS = [
  {
    n: "01",
    title: "The House",
    body: "99 Institute of Beauty & Wellness is Patiala's atelier for skin, hair, makeup and mastery. A salon on the ground floor, an academy on the mezzanine — both built around one obsession: craft you can feel.",
  },
  {
    n: "02",
    title: "The Craft",
    body: "From a single trim to a full bridal edit, every service is engineered with senior artists, professional-grade formulations from L'Oréal, Schwarzkopf, Matrix and O3+, and a slow, considered pace that respects your time.",
  },
  {
    n: "03",
    title: "The Academy",
    body: "IAO-accredited certificate, diploma and long-term programs in hair, makeup, skin, nails and body. Trained by working artists, on live clients, in a studio that already looks like the industry you're stepping into.",
  },
  {
    n: "04",
    title: "The Feeling",
    body: "Low light, warm hands, the quiet weight of a heated towel. You walk in a person. You walk out a mood. That is the 99 signature.",
  },
];

export const WHY = [
  {
    n: "01",
    title: "IAO Accredited",
    body: "Our academy is accredited by the International Accreditation Organization — your certificate is recognised globally.",
  },
  {
    n: "02",
    title: "Salon-inside-Academy",
    body: "Learn on real clients from day one. Every student trains on the same floor our senior artists work.",
  },
  {
    n: "03",
    title: "Pro-Grade Only",
    body: "L'Oréal, Schwarzkopf, Matrix, MAC, Kryolan, O3+, Olaplex, Wellaplex — never a downgrade.",
  },
  {
    n: "04",
    title: "Bridal Specialists",
    body: "From engagement to reception — a dedicated bridal team, six make-up brand options, and a private suite.",
  },
  {
    n: "05",
    title: "Slow Luxury",
    body: "No rushed chairs. Every appointment gets its own time block, so you leave the way you deserve to.",
  },
  {
    n: "06",
    title: "Patiala Roots",
    body: "Born in Patiala, near Fountain Chowk. A neighbourhood house, run with international standards.",
  },
];
